import React from "react";
import "./CheckBox.css";

export default function CheckBoxNoFormik(props) {
  const checked = props.checked;

  return (
    <label className="check-box">
      <input
        type="checkbox"
        checked={checked}
        onChange={event => {
          if (props.onChange) {
            props.onChange(event);
          }
        }}
        disabled={props.disabled}
      />
      {checked ? (
        <i className="check-box__icon check-box__icon--checked material-icons">
          check
        </i>
      ) : (
        <i className="check-box__icon" />
      )}
      <span className="check-box-label">{props.label}</span>
    </label>
  );
}
